import { useState } from "react";
import { createFeedApi } from "../../app/api";
import Cookies from "js-cookie";
import { createPortal } from "react-dom";

export default function CreatePostModal({ showModal, setShowModal, onPostCreated }) {

  const [postText, setPostText] = useState("");
  const [imageFile, setImageFile] = useState(null);

  const handleCreate = async () => {
    const token = Cookies.get("token");
    if (!token) {
      alert("You are not logged in!");
      return;
    }

    if (!postText.trim() && !imageFile) return;

    const formData = new FormData();
    formData.append("type", "post");
    formData.append("priority", 1);
    formData.append("meta", JSON.stringify({ message: postText }));

    if (imageFile) {
      formData.append("image", imageFile);
    }

    const res = await createFeedApi(formData, true);

    if (res.success) {
      setPostText("");
      setImageFile(null);
      setShowModal(false);
    //   onPostCreated(); // reload feeds
    onPostCreated?.();
    }
  };

  if (!showModal) return null;

  return createPortal(
    <div className="fixed inset-0 bg-black/30 backdrop-blur-md flex items-center justify-center z-[9999]">

      <div className="relative w-[420px] rounded-2xl bg-white/10 backdrop-blur-xl border border-white/20 shadow-2xl p-6 text-white">

        <button
          onClick={() => setShowModal(false)}
          className="absolute top-3 right-4 text-white/70 hover:text-red-300 text-xl"
        >
          ✕
        </button>

        <h2 className="text-lg font-semibold mb-4 flex justify-center">
          Create Post
        </h2>

        <textarea
          placeholder="What's on your mind?"
          value={postText}
          onChange={(e) => setPostText(e.target.value)}
          className="w-full bg-white/10 border border-white/20 p-3 rounded-lg outline-none shadow-lg"
        />

        <input
          type="file"
          accept="image/*"
          onChange={(e) => setImageFile(e.target.files[0])}
          className="mt-4 text-sm text-white/80"
        />

        <button
          onClick={handleCreate}
          className="mt-5 w-full bg-[#2C1A60] hover:bg-[#39227c] py-2 rounded-xl font-semibold"
        >
          Post
        </button>

      </div>

    </div>,
        document.body
  );
}